<template>
  <div>
    <p class="font--p-3 mt-5">
      사업장의 건전성 판단을 위해 <br />
      홈텍스 계정이 필요합니다.
    </p>
    <v-card class="mb-5" flat style="background-color: #e5f6ff">
      <v-card-title class="font-size--14 color--nice" style="padding:8px;">
        걱정하지 마세요! 계정 정보는 암호화 후 안전하게 보관됩니다.
      </v-card-title>
    </v-card>
    <v-card flat v-for="(account, index) in accounts" :key="account.provider">
      <v-card-title>
        <BasicCheckbox
          v-if="account.required === false"
          v-model="account.edited"
          :checked.sync="account.edited"
          :name="`cb_${index}`"
          :disabled="!account.uuid && account.required"
        >
        </BasicCheckbox>
        <label
          class="font--m-3"
          :for="`cb_${index}`"
          style="display: flex; align-items: center"
          v-bind:style="account.required ? 'color: #14AFFF;' : 'color:black;'"
        >
          ({{ account.required ? '필수' : '선택' }})
        </label>
        <span class="font--m-3">&nbsp;{{ account.name }} </span>
        <img class="ml-5" :src="account.image" style="width: 50px" />
        <!-- </label> -->
      </v-card-title>
      <v-card-text v-if="!account.uuid">
        <v-text-field
          v-model="account.userId"
          placeholder="아이디 입력"
          :disabled="!account.edited"
          @keydown.space.prevent
        ></v-text-field>
        <v-text-field
          v-model="account.userPassword"
          placeholder="비밀번호 입력"
          type="password"
          :disabled="!account.edited"
          @keydown.space.prevent
        ></v-text-field>
      </v-card-text>
      <v-card flat v-if="account.uuid">
        <v-card-title style="background-color: #e5f6ff" class="justify-center pt-10 pb-10 font--m-3"
          >계정 연동 완료!
        </v-card-title></v-card
      >
    </v-card>
    <BasicButton
      @click="save(editedAccounts)"
      :loading="nextLoading"
      :disabled="nextLoading || !checkRequired"
      >{{ btnText ? btnText : '계정 등록하기' }}</BasicButton
    >
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    btnText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      accounts: [
        {
          provider: 'hometax',
          name: '홈택스',
          userId: '',
          userPassword: '',
          valid: false,
          invalidMsg: '',
          edited: true,
          required: true,
          uuid: null,
          image: require('@/assets/images/accounts/hometax.jpg'),
        },
      ],
      nextLoading: false,
    }
  },
  computed: {
    ...mapState('account', {
      storeAccounts: 'accounts',
    }),
    editedAccounts() {
      return this.accounts.filter((ac) => ac.edited === true)
    },
    requiredAccount() {
      return this.accounts.find((ac) => ac.required === true)
    },
    checkRequired() {
      if (this.requiredAccount?.uuid) {
        return true
      }
      //this.accounts에서 required는 true인것이 userID와 UserPassword가 존재해야 해서 true를 리턴해줘
      return [this.requiredAccount].every((ac) => ac.userId && ac.userPassword)
    },
  },
  async created() {
    await this.getAccounts()
    this.syncAccounts(this.storeAccounts)
  },
  watch: {
    storeAccounts(v) {
      this.syncAccounts(v)
    },
    editedAccounts: {
      deep: true,
      handler(v) {
        v.filter((ac) => ac.required === true || ac.edited === true).forEach((ac) => {
          if (ac.userId.length > 2 && ac.userPassword.length > 2) {
            ac.valid = true
          } else {
            ac.valid = false
          }
        })
      },
    },
  },
  methods: {
    ...mapActions('account', ['addAccount', 'updateAccount', 'getAccounts']),
    async syncAccounts(data) {
      if (!data) {
        return
      }
      // console.log(await this.getAccounts())
      for (const ac of data) {
        this.accounts
          .filter((f) => f.provider === ac.provider)
          .forEach((f) => (f = Object.assign(f, ac, { edited: false })))
      }
    },
    async save(editedAccounts) {
      try {
        this.nextLoading = true

        for (const account of editedAccounts) {
          try {
            if (account.uuid) {
              await this.updateAccount(account)
            } else {
              await this.addAccount(account)
            }
          } catch (e) {
            if (e.status === 400) {
              const { nonFieldErrors } = e.data
              if (nonFieldErrors && nonFieldErrors[0].indexOf('invalid user_id') > -1) {
                return await this.$swal.basic.error({
                  html: `${account.name}의 아이디/비밀번호가 맞지 않습니다. <br/>다시 입력해주세요.`,
                })
              }
              throw e
            }

            throw e
          }
        }
        if (this.requiredAccount?.uuid) {
          return this.$emit('emitResult', true)
        } else {
          return await this.$swal.basic.error({
            html: `필수 입력 값을 확인 해주세요`,
          })
        }


      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>
